import { useQuery } from "@tanstack/react-query";
import { camelizeKeys } from "humps";
import { ObservationCategoriesSchema as Schema } from "src/features/Admin/Observations/models";
import cmsClient from "src/services/cmsClient";

const fetchPublishedFormsCategories = async () => {
	const url = "/observations/forms/categories/";

	const response = await cmsClient.get(url);
	const camelizedData = camelizeKeys(response.data);

	return Schema.parse(camelizedData);
};

type UsePublishedFormsCategoriesOptions = {
	enabled?: boolean;
};

const usePublishedFormsCategories = (
	options: UsePublishedFormsCategoriesOptions = { enabled: true }
) => {
	const queryKey = ["observation-categories-published"];
	const queryFn = fetchPublishedFormsCategories;
	const { enabled } = options;

	const query = useQuery({
		queryKey,
		queryFn,
		enabled
	});

	return query;
};

export default usePublishedFormsCategories;
